<template>
    <div class="user" v-if="isAuthenticated">logged in as <strong><router-link :to="{name: 'profile', params: { id: username }}">{{ username }}</router-link></strong> | <router-link :to="{ name: 'logout' }">logout</router-link></div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed:  {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapState({
            username: state => state.user.identity.username
        }),
  
}
}
</script>

<style scoped>
    
    .user {
        background-color: orange;
        position: absolute;
        top: 0;
        right:0;
        padding: 17px 20px 17px 20px;
        font-size: 90%;
    }

@media only screen and (max-width: 900px) {

    .user {
        padding: 2px 10px 2px 10px;
        margin: 0;
    }

}

</style>
